import React from "react";
import { Link } from "react-router-dom";
import instagram from "../assets/instagram.svg";
import Circles from "../components/Circles";
import Button from "../components/Button";
import Nav from "../components/Nav";

function Thanks() {


  return (
    <section className="bg-petrol-500">
      <Nav />
      <div className="container">
        <h1 className="mb-40 sm:mt-64 mt-40">
          Du är nu med i tävlingen! Hoppas vi ses i finalen på Frölunda Torg!
        </h1>
        <div className="flex w-full flex-col items-center gap-[30px] mt-auto">
        <Link to="/quiz">
          <Button
            text="Spela igen"
            buttonClass="secondary"
          />
          </Link>
          <Link to="/topplistan">
            <Button
              text="Topplistan"
              buttonClass="primary"
            />
          </Link>
        </div>
      </div>
      <Circles color="bg-syren-300" />
    </section>
  );
}

export default Thanks;
